import React, { useState, useEffect } from "react"
import { Button, Card, Divider, Loader, Dimmer } from "semantic-ui-react"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { getUpdatedCart } from "../../../../v1/helpers/orderHelpers"
import { routerPaths } from "../../../../v1/constants/paths"
import ServiceTile from "../ReviewRequest/ServiceTile"
import { PricedAtShop } from "../PricedAtShop"
import { updateCart } from "../../../../v1/actions/user"
import {
  gaJSON,
  trackFirebaseAnalytics
} from "../../../../shared_component/utils/googleAnalyticsHelpers"
import { withRouter } from "react-router-dom"

const ConfirmServices = ({
  t,
  history,
  cart,
  user,
  onGoBack,
  updateCart,
  activeVehicle,
  order
}) => {
  const [isLoading, setIsLoading] = useState(false)
  let services = cart.order_services || []
  const subtotal = services.reduce((sum, service) => {
    const rawPrice = service?.price_estimate?.shop_price_estimate
    const price = parseFloat(rawPrice)
    return sum + (!isNaN(price) ? price : 0)
  }, 0)

  useEffect(() => {
    services = cart.order_services || []
    trackFirebaseAnalytics({
      event: gaJSON.price_comparison_viewed,
      params: {
        [gaJSON.services]: services,
        [gaJSON.services_count]: services.length
      }
    })
  }, [])

  const getServices = () => {
    let updatedCartData = getUpdatedCart(user, order, props)
    services = updatedCartData.cart.order_services
  }

  const removeService = async (os, event) => {
    setIsLoading(true)
    let opts = {
      isOrder: order && !order.is_tire_order,
      orderId: order && order.id,
      successCallback: async () => {
        trackFirebaseAnalytics({
          event: gaJSON.service_selected,
          params: {
            [gaJSON.service_name]: os.name,
            [gaJSON.service_type]: !os.position ? os.name : `${os.name} - ${os.position}`,
            [gaJSON.from_where]: window.location.hash,
            [gaJSON.vehicle_name]: activeVehicle
              ? `${activeVehicle?.year || ""} ${activeVehicle?.make?.toUpperCase() || ""} ${
                  activeVehicle?.model?.toUpperCase() || ""
                }`
              : null
          }
        })
      }
    }
    try {
      await updateCart(
        [
          {
            service_definition_id: os.service_id || os.id || os.service_definition_id,
            event: event,
            prepaid: os.prepaid,
            position: os.position
          }
        ],
        cart.vehicle_id,
        undefined,
        undefined,
        opts
      )
      getServices()
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      return { error: error.message }
    }
  }

  const handleStartBooking = () => {
    const comparePriceData = {
      selectedServices: services,
      selectedShopId: cart.shop.id || 0,
      subTotal: subtotal
    }
    localStorage.setItem("comparePriceData", JSON.stringify(comparePriceData))
    history.push({ pathname: routerPaths.updateUser })
  }

  return (
    <>
      <Dimmer active={isLoading}>
        <Loader>Loading...</Loader>
      </Dimmer>
      <Card className="compare-service-card review-request-container" raised>
        <div className="compare-service-content">
          <p className="compare-request-title">
            {t("youHaveSelected")}{" "}
            <b>
              {services.length} {services.length > 1 ? "services" : "service"}
            </b>
          </p>
          {services.map((service, idx) => (
            <ServiceTile key={service.id} service={service} handleService={removeService} />
          ))}
          <Divider />
          <div className="compare-services-subtotal-row">
            <span>{t("subtotal")}</span>
            {subtotal != 0 && user && user.country !== "ca" ? (
              <b className="review-services-subtotal">
                {t("Starting at")} ${Number(subtotal).toFixed(2)}
              </b>
            ) : (
              <PricedAtShop />
            )}
          </div>
        </div>
        <Button
          fluid
          color="orange"
          className="primary-button"
          onClick={handleStartBooking}
          disabled={services.length === 0}
          style={{ marginBottom: "10px" }}
        >
          {t("startBooking")}
        </Button>
        <Button fluid basic color="black" className="secondary-button" onClick={onGoBack}>
          {t("goBack")}
        </Button>
      </Card>
    </>
  )
}
function mapStateToProps(state, props) {
  let user = state.user || {}
  let cart
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)

  const order =
    activeVehicle &&
    activeVehicle.id &&
    (user.active_orders || []).find((o) => o.vehicle_id === activeVehicle.id)
  let updatedCartData = getUpdatedCart(user, order, props)
  if (updatedCartData) {
    cart = updatedCartData.cart
  }

  return {
    cart: cart,
    user: user,
    activeVehicle,
    order
  }
}

export default withRouter(
  connect(mapStateToProps, { updateCart })(withTranslation("addService")(ConfirmServices))
)
